<div class="header_search">
  <div class="title-page">
    <h3>Demandas de Monitoramento</h3>
  </div>
  <div class="content_search">
    <div class="new-demand">
      <button class="btn-back" type="btn" (click)="mostrarCanceladas()">{{canceladas ? 'Ocultar' : 'Mostrar'}} Canceladas e Concluídas</button>
    </div>
    <div class="new-demand" *ngIf="canDemand">
      <a class="btn btn-primary" type="btn" routerLink="adicionar">Nova Demanda</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="text-center">Código</th>
          <th>Item Monitorado</th>
          <th>Título</th>
          <th>Andamento</th>
          <th class="text-center">Situação</th>
          <th class="text-center">Prazo</th>
          <th>Solicitante</th>
          <th>Atribuído</th>
          <th class="text-center">Alterado em</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of demandas">
          <tr *ngIf="!item?.hidden || this.canceladas">
            <td class="title text-center"> {{item?.id}}</td>
            <td>{{item?.monitored_item}}</td>
            <td>{{item?.subject}}</td>
            <td>{{item?.issue_sub_stat_name}}</td>
            <td class="status">
              <div>
                <span [innerHTML]="item?.status1"></span>
                {{item?.issue_stat_name}}
              </div>
            </td>
            <td class="text-center">{{item?.dt_foreseen_end}}</td>
            <td>{{item?.demandant_name}}</td>
            <td>{{item?.defendant_name}}</td>
            <td class="text-center">{{item?.ctr_dth_atu}}</td>
            <td>
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="view(item?.id)" *ngIf="item?.canDemand">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!demandas?.length" class="border-b-radius">
          <td colspan="10" class="text-center">Nenhuma Demanda de Monitoramento Cadastrada.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>